const STAR_MAP = {
    0: '',
    1: 'Terrible',
    2: 'Bad',
    3: 'Average',
    4: 'Good',
    5: 'Excellent'
};

export { STAR_MAP };
